exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".isPortraitStyle{padding:0!important}", ""]);

// exports
